import { Fragment, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';

import { getAppData } from '../../app/environment/environmentSlice';
import '../../helpers/fontawesomeLibrary';
import './styles.css';

export default function Footer() {
    const appData = useSelector(getAppData);
    const [footerLinks, setFooterLinks] = useState([]);
    const [aepTermLink, setAepTermLink] = useState({});
    useEffect(() => {
        if(!isEmpty(appData)) {
            const { REACT_APP_AEP_TERM_FOOTER_LINK, REACT_APP_FOOTER_LINK } = appData;
            const parsedAEPTerm = REACT_APP_AEP_TERM_FOOTER_LINK && JSON.parse(REACT_APP_AEP_TERM_FOOTER_LINK);
            const parsedFooter = REACT_APP_FOOTER_LINK && JSON.parse(REACT_APP_FOOTER_LINK);
            setAepTermLink(parsedAEPTerm);
            setFooterLinks(parsedFooter);
        }
    }, [appData]);
    
    return (
        <Row className='footer py-3'>
            <div className="text-center text-light">
                Use of this site constitutes acceptance of the&nbsp;
                <span className="fw-bold">
                    {
                        aepTermLink && (
                            <a rel="noopener noreferrer" href={aepTermLink.link} target="_blank">
                                {aepTermLink.label}
                                &nbsp;
                                <span className="fa-1x">
                                    <FontAwesomeIcon icon={['fas', 'external-link']} size="sm" />
                                </span>
                            </a> 
                        )
                    }          
                </span>.
                &copy; AEP -  American Electric Power Company, Inc. All Rights Reserved.
                <Row>
                    <div className="text-center text-uppercase">
                        {
                            footerLinks && footerLinks.map((footer, index) => (
                                <Fragment key={footer.label}>
                                    <a rel="noopener noreferrer" key={footer.label} href={footer.link} target="_blank">
                                        {footer.label}
                                        &nbsp;
                                        <FontAwesomeIcon key={`external-link-${footer.label}`} icon={['fas', 'external-link']} size="sm" />
                                    </a>
                                    {index !== footerLinks.length -1 && <>&nbsp;|&nbsp;</>}
                                </Fragment>
                            ))
                        }
                    </div>
                </Row>
            </div>
        </Row>
    );
}
